/* Scheda prodotto — griglia editoriale: foto a schermo intero al click (Esc o click per chiudere). */
(function () {
  'use strict';
  var grid = document.querySelector('[data-pdp-grid]');
  if (!grid) return;
  var overlay = null;
  var lastFocus = null;

  function close() {
    if (!overlay) return;
    var o = overlay; overlay = null;
    o.classList.remove('is-on');
    document.removeEventListener('keydown', onKey);
    setTimeout(function () { if (o.parentNode) o.parentNode.removeChild(o); }, 350);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function onKey(e) { if (e.key === 'Escape') close(); }
  function open(src, alt) {
    lastFocus = document.activeElement;
    overlay = document.createElement('div');
    overlay.className = 'beezfy-pdp-zoom';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    var img = document.createElement('img');
    img.src = src; img.alt = alt || '';
    var btn = document.createElement('button');
    btn.type = 'button'; btn.setAttribute('aria-label', 'Chiudi'); btn.innerHTML = '&times;';
    overlay.appendChild(img); overlay.appendChild(btn);
    overlay.addEventListener('click', close);
    document.body.appendChild(overlay);
    document.addEventListener('keydown', onKey);
    btn.focus();
    window.requestAnimationFrame(function () { if (overlay) overlay.classList.add('is-on'); });
  }

  grid.addEventListener('click', function (e) {
    var img = e.target.closest ? e.target.closest('img[data-pdp-grid-full]') : null;
    if (!img) return;
    open(img.getAttribute('data-pdp-grid-full') || img.src, img.alt);
  });
})();
